import { useMemo } from "react";
import dayjs from "dayjs";
import { Bar } from "react-chartjs-2";
import { Activity, Flame, PhoneCall, Timer } from "lucide-react";
import Panel from "./Panel";
import { chartColor } from "../../../components/dashboard/shared";

const SERIES = [
    { key: "call", label: "Calls", color: 1 },
    { key: "whatsapp", label: "WhatsApp", color: 3 },
    { key: "email", label: "Email", color: 2 },
    { key: "visit", label: "Visits", color: 4 },
    { key: "demo", label: "Demos", color: 5 },
    { key: "other", label: "Notes / other", color: null },
];

const fmtTalk = (s) => {
    if (!s) return "0m";
    const h = Math.floor(s / 3600);
    const m = Math.round((s % 3600) / 60);
    return h ? `${h}h ${m}m` : `${m}m`;
};

const Stat = ({ icon: Icon, label, value }) => (
    <div className="flex items-center gap-2 min-w-0">
        <Icon className="h-4 w-4 text-brand-500 flex-shrink-0" />
        <div className="min-w-0">
            <p className="text-sm font-bold text-gray-900 dark:text-white tabular-nums">{value}</p>
            <p className="text-[11px] text-gray-500 dark:text-gray-400 truncate">{label}</p>
        </div>
    </div>
);

// What I logged over the last seven days, stacked by channel.
const WeeklyActivity = ({ activity, loading }) => {
    const a = activity || { days: [] };
    const chart = useMemo(() => ({
        labels: a.days.map(d => dayjs(d.date).format("ddd")),
        datasets: SERIES.map(s => ({
            label: s.label,
            data: a.days.map(d => d[s.key] || 0),
            backgroundColor: s.color ? chartColor(s.color, 0.85) : "rgba(156,163,175,0.6)",
            borderRadius: 3,
            stack: "a",
        })),
    }), [a.days]);
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: { legend: { position: "bottom", labels: { boxWidth: 10, font: { size: 10 } } } },
        scales: {
            x: { stacked: true, grid: { display: false } },
            y: { stacked: true, beginAtZero: true, ticks: { precision: 0 } },
        },
    };
    return (
        <Panel title="My activity this week" icon={Activity} loading={loading}>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-3">
                <Stat icon={Activity} label="activities" value={a.total ?? 0} />
                <Stat icon={PhoneCall} label="connect rate" value={a.connect_rate === null || a.connect_rate === undefined ? "—" : `${a.connect_rate}%`} />
                <Stat icon={Timer} label="talk time" value={fmtTalk(a.talk_seconds)} />
                <Stat icon={Flame} label="day streak" value={a.streak_days ?? 0} />
            </div>
            <div className="h-48">
                <Bar data={chart} options={options} />
            </div>
        </Panel>
    );
};

export default WeeklyActivity;
